import { ECountryCode } from 'src/modules/forms/fields/AreaCodeTextField/components/AreaCodeSelect';

export const CONTACT_PHONE_RULES = [
    {
        prefix: '521',
        countryCode: ECountryCode.Mexico,
    },
    {
        prefix: '52',
        countryCode: ECountryCode.Mexico,
    },
    {
        prefix: '55',
        countryCode: ECountryCode.Brazil,
    },
    {
        prefix: '1',
        countryCode: ECountryCode.USA,
    },
] as const;

export const CONVERSATION_CONTACT_UPDATE_FIELDS = {
    displayName: 'contact.displayName',
    phone: 'contact.phone',
    linkedContact: 'linkedContact',
} as const;

export const CONTACT_DETAILS_ROUTE = '/management/contacts';

export const CONTACT_REGISTRATION_LABELS = {
    viewContact: 'ViewContact',
} as const;
